import { render, staticRenderFns } from "./DeptUserTreeMT.vue?vue&type=template&id=974a69d6&scoped=true&"
import script from "./DeptUserTreeMT.vue?vue&type=script&lang=js&"
export * from "./DeptUserTreeMT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974a69d6",
  null
  
)

export default component.exports